import React, { useState, useEffect, useRef } from "react";
import "./styles/global.css";
import Register from "./components/Register";
import Navbar from "./components/Navbar";
import CookieManager from "./services/CookieManager";
import ListTracks from "./components/ListTracks";
import Sidebar from "./components/Sidebar";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Switch, Route, withRouter, Redirect } from "react-router-dom";
import EmailVerification from "./components/EmailVerification";
import Projects from "./components/Projects";
import Favorites from "./components/Favorites";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MediaPlay from "./components/MediaPlay";
import PlayHistory from "./components/PlayHistory";
import Downloads from "./components/Downloads";
import Amplitude from "amplitudejs";
//import License from './components/License'
import AllLicenses from "./components/License/all-licenses";
import SingleLicense from "./components/License/license";
import TrackContext from "./contexts/track-context";
import { LinearProgress } from "@material-ui/core";
import Signin from "./components/Register/signin";
import SignupConfirm from "./components/Register/signupconfirm";
import SignupVerify from "./components/Register/signupverify";
import Footer from "./pure-components/Footer";
import { Link } from "react-router-dom";
import Helper from "./services/helper";
import Profile from "./components/Profile";
import Billing from "./components/Billing";
import Constants from "./services/constants";
import Support from "./components/Support";
import API from "./services/api";
import SubscribePopup from "./pure-components/SubscribePopup";
import AlertSubscribePopup from "./pure-components/AlertSubscribePopup";
import ForgotPassword from "./components/Register/forgot-password";
import SetNewPassword from "./components/Register/set-new-password";
import Admin from "./components/Admin";
import ChoosePlan from "./components/ChoosePlan";
import NotFoundPage from "./components/NotFoundPage";
import AlbumDetails from "./components/AlbumDetails";
import Voicegen from "./components/Voicegen";
import ErrorBoundary from "./pure-components/ErrorBoundary";
import musicImage from "./assets/default_music.png";
import NewInspiration from "./components/NewInspiration";
import PlaylistDetails from "./components/PlaylistDetails";
import LicenseInsight from "./components/Admin/licenseInsight";
import ArtistTrackView from "./components/ArtistTrackView";
import SoundFx from "./components/SoundFx";
import LogoutPopup from "./pure-components/LogoutPopup";
import MewoService from "./services/mewoService";
import { toast } from "react-toastify";
import { ErrorToast } from "../src/pure-components/CustomToast";
import Catalog from "./components/Catalog";
import CatalogAlbum from "./components/Catalog/catalog-album";
import ReactGA from "react-ga";
import RouteChangeTracker from "./services/RouteChangeTracker";
// import HomePage from "./components/LandingPage";

import HarmixLibrary from "./components/Harmix/library";

import AboutUs from "./components/KnowledgeBase/AboutUs";
import ServiceTerms from "./components/KnowledgeBase/TermsServices";
import PrivacyPolicy from "./components/KnowledgeBase/PrivacyPolicy";
import CookiesPolicy from "./components/KnowledgeBase/Cookies";
import ContactUs from "./components/KnowledgeBase/ContactUs";
import Faqs from "./components/KnowledgeBase/FAQPage";
import CountryNotAvailable from "./components/KnowledgeBase/CountryNotAvailable";
import HarmixAdmin from "./components/Harmix/admin/admin";

import Enrol from "./components/Enrol";
import Login from "./components/Enrol/login"
import SubscriptionInfo from "./components/Subscription/subscriptionInfo";
import ActionRecords from "./components/ActionRecords";
import Music from "./components/Music";
import { ThemeProvider } from "./contexts/theme-context";
import SideMenu from "./components/NewUI/sideMenu";
import Account from "./components/Profile/account";
import AiSearch from "./components/Navbar/aiSearch";
import AddTrackToProjectPopup from "./components/Projects/addTrackToProjectPopup";
import SFX from "./components/SoundFx/sfx";
import { StaticHtmlLoader } from "./services/staticFileLoader";
import HomePage from "./components/MarketingSite/LandingPage"
import AboutPage from "./components/MarketingSite/AboutPage";
import MobileTopNav from "./components/Navbar/mobileTopNav";
import BlogListing from "./components/Blog/BlogListing";
import BlogDetail from "./components/Blog/BlogDetail";

export default withRouter(function App({ location, match }) {
  // ensure theme key is initialized and kept in sync with older `sm-theme`
  const _storedTheme = localStorage.getItem("sm-theme") || "dark";
  try {
    localStorage.setItem("sm-theme", _storedTheme);
  } catch (e) {
    // ignore storage errors
  }

  const isLoggedIn = () => {
    let loggedIn = false;
    const userData = CookieManager.getCookie("user-data");
    if (userData !== undefined && userData !== null && userData !== "null") {
      loggedIn = true;
    }
    return loggedIn;
  }
  const [userSignedIn, setUserSignedIn] = useState(isLoggedIn());
  const [loadingTrack, setLoadingTrack] = useState(false);
  const [userDetails, setUserDetails] = useState(JSON.parse(CookieManager.getCookie("user-data") || "{}"));
  const [path, setCurrentPathname] = useState("/");
  const [currentTrack, setCurrentTrack] = useState("");
  const [previousTrack, setpreviousTrack] = useState(-1); // it wil remove
  const [trackData, setTrackData] = useState([]);
  const [currentTrackImage, setCurrentTrackImage] = useState("");
  const [currentTrackDetail, setCurrentTrackDetail] = useState({});
  const [resultFromMaia, setResultFromMaia] = useState([]);
  const [maiaOnWork, setMaiaOnWork] = useState(false);
  const [playPause, setPlayPause] = useState(false);
  const [totaltracks, setTotaltracks] = useState(0);
  const [searchkey,setSearchkey]=useState(""); 
  const [searchResultView, setSearchResultView] = useState(Constants.SEARCH_RESULT_VIEW_TYPE.tracks);
  const [filterMenu, setFilterMenu] = useState( [
    { key: "mood", value: "MOODS" },
    { key: "genres", value: "GENRES" },
    { key: "instruments", value: "INSTRUMENTS" },
    { key: "structures", value: "STRUCTURES" },
    { key: "style", value: "STYLES" },
    { key: "usage", value: "USAGES" },
    { key: "duration", value: "DURATION", isSlider: true },
    { key: "bpm", value: "BPM", isSlider: true },
  ]
);
  const [trackFilter, setTrackFilter] = useState({
    searchTags: {},
    selectedTags: [],
    bpm: [],
    duration: [],
    fetchList: true,
    searchText: "",
    url: "",
    searchTitle: "",
    selectedChildTags: [],
    searchId: "",
    fileName: "",
    trackId: "",
  });
  const [searchAlbums, setSearchAlbums] = useState(false);
  const filterDefaultMenu =  [
    { key: "mood", value: "MOODS" },
    { key: "genres", value: "GENRES" },
    { key: "instruments", value: "INSTRUMENTS" },
    { key: "structures", value: "STRUCTURES" },
    { key: "style", value: "STYLES" },
    { key: "usage", value: "USAGES" },
    { key: "duration", value: "DURATION", isSlider: true },
    { key: "bpm", value: "BPM", isSlider: true },
  ]

  const filterData ={
    searchTags: {},
    selectedTags: [],
    bpm: [],
    duration: [],
    fetchList: true,
    searchText: "",
    url: "",
    searchTitle: "",
    selectedChildTags: [],
    searchId:"",
    fileName:"",
    trackId:"",
  }

  const excludedTagIDs = ["621fa40f4576ab0016018578"]
  
  //Initializing Google Analytics dependency
  ReactGA.initialize(Constants.GA_MEASURMENT_ID);

  // Check if user is admin or super admin
  const isAdminOrSuperAdmin =
    userDetails?.userType === JSON.parse(process.env.REACT_APP_USER_TYPE)?.ADMIN ||
    userDetails?.userType === JSON.parse(process.env.REACT_APP_USER_TYPE)?.SUPER_ADMIN;

  useEffect(() => {
    //
    if (window.location.pathname === "/"||
        window.location.pathname.startsWith( `/search/track`)||
        window.location.pathname.startsWith( `/search/albums/`)
     ) {
      setFilterMenu(
        JSON.parse(localStorage.getItem("filterMenu_music")) || filterDefaultMenu
      );
      setTrackFilter(JSON.parse(localStorage.getItem("filter_music"))  || filterData
      );
    } else if (window.location.pathname.startsWith("/sound-design")||
               window.location.pathname.startsWith(`/sound-design/search/track/`)||
               window.location.pathname.startsWith(`/sound-design/search/albums/`)

      ){
      setFilterMenu(
        JSON.parse(localStorage.getItem("filterMenu_soundfx"))||filterDefaultMenu
      );
      setTrackFilter(JSON.parse(localStorage.getItem("filter_soundfx")) || filterData

      );
    }
  }, [location.pathname]);

  useEffect(() => {
     if (window.location.pathname === "/"||
       window.location.pathname.startsWith( `/search/track`)||
       window.location.pathname.startsWith( `/search/albums/`) 
    ) {
      localStorage.setItem("filterMenu_music", JSON.stringify(filterMenu));
      localStorage.setItem("filter_music", JSON.stringify(trackFilter));
    }
     else if (window.location.pathname === ("/sound-design")||
     window.location.pathname.startsWith(`/sound-design/search/track/`)||
     window.location.pathname.startsWith(`/sound-design/search/albums/`)

     ) {
      localStorage.setItem("filterMenu_soundfx", JSON.stringify(filterMenu));
      localStorage.setItem("filter_soundfx", JSON.stringify(trackFilter));
    }
  }, [filterMenu, trackFilter]);

  const [loading, setIsLoading] = useState(true);
    // const [filterMenu,setFilterMenu] = useState([{ key: "mood", value: "MOODS" }, { key: "genres", value: "GENRES" }, { key: "instruments", value: "INSTRUMENTS" },
  //   { key: "structures", value: "STRUCTURES" }, { key: "style", value: "STYLES" }, { key: "usage", value: "USAGES" }, { key: "duration", value: "DURATION",isSlider:true },
  //    { key: "bpm", value: "BPM",isSlider:true }]);
  // const [trackFilter, setTrackFilter] = useState({searchTags:{},selectedTags:[],bpm:[],duration:[],fetchList:true,searchText:'',url:''});
  const [showSubscribePopup, setShowSubscribePopup] = useState(false);
  const [showAlertPopups, setShowAlertPopups] = useState(false);
  const [currPage, setCurrPage] = useState(1);
  const [userAction, setUserAction] = useState("");
  const [error, setError] = useState("");
  const [dashboardMenu, setDashboardMenu] = useState([
    { key: "My Projects", value: "/projects" },
    { key: "My Favourites", value: "/favourites" },
    { key: "My Play History", value: "/history" },
    { key: "My Profile", value: "/profile" },
    { key: "Subscription", value: "/subscription" },
    // { key: "My Invoices", value: "/billing" },
    { key: "Support", value: "/support" },
  ]);
  const [showProjectModal, setShowProjectModal] = useState(false);
  const [trackToBeAddedToProject, setTrackToBeAddedToProject] = useState("");
  const [clearData, setClearData] = useState(false);
  const [showMayaLoader, setShowMayaLoader] = useState(false);
  const [allTracksLoaded, setAllTracksLoaded] = useState(false);
  const [resultFromMawoSearch, setResultFromMawoSearch] = useState(false);
  const [filterSubMenu, setFilterSubMenu] = useState([]);
  const [filterSubMenuChild, setFilterSubMenuchild] = useState([]);
  const [searchTime,setSearchTime]=useState(0);
  const [intervalID,setIntervalId]=useState(null);
  const [stopSearch, setStopSearch] = useState(false);
  const [showProgress,setShowProgress]=useState(false);
  const [progress,setProgressValue]=useState(0);
  const [fileName,setAudioFileName]=useState('');
  const [isFileUpload,setFileUpload]=useState(false); // file upload flag
  const [cancelToken,setCancelToken]=useState(); // token for cancel file upload request 
  const [AISearch,setSearch]=useState(false);
  const [showLoaderMagic, setShowLoaderMagic] = useState(false)
  const [songData,setSongData]=useState([]);// holds track data for autoplay next track
  const [alltrackData,setalltrackData]=useState([]);//holds data to play next or prev track
  const [playingFrom,setPlayingFrom]=useState('');//holds page refrence from where track is played
  const [searchDescription, setSearchDescription] = React.useState(false);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);

   //set default image function
    const setDefaultImage=(event)=>{
    //replacement of broken Image
    event.target.src = musicImage;
  };
  useEffect(() => {
    if (window.location.pathname === "/"||window.location.pathname.startsWith( `/search/track`)) {
      localStorage.setItem(
        "filterSubMenu_music",
        JSON.stringify(filterSubMenu)
      );
      localStorage.setItem(
        "filterSubMenuChild_music",
        JSON.stringify(filterSubMenuChild)
      );
    } else if (window.location.pathname === "/sound-design"||window.location.pathname.startsWith(`/sound-design/search/track/`)) {
      localStorage.setItem(
        "filterSubMenu_soundfx",
        JSON.stringify(filterSubMenu)
      );
      localStorage.setItem(
        "filterSubMenuChild_soundfx",
        JSON.stringify(filterSubMenuChild)
      );
    }
  }, [filterSubMenu, filterSubMenuChild]);

  useEffect(() => {
    const userData = CookieManager.getCookie("user-data");
    if (userData !== undefined && userData !== null && userData !== "null") {
      setUserSignedIn(true);
    }

    if (window.location.pathname === "/"||window.location.pathname.startsWith( `/search/track`)) {
      setFilterSubMenu(
        JSON.parse(localStorage.getItem("filterSubMenu_music")) || []
      );
      setFilterSubMenuchild(
        JSON.parse(localStorage.getItem("filterSubMenuChild_music")) || []
      );
    } else if (window.location.pathname === "/sound-design"||window.location.pathname.startsWith(`/sound-design/search/track/`)) {
      setFilterSubMenu(
        JSON.parse(localStorage.getItem("filterSubMenu_soundfx")) || []
      );
      setFilterSubMenuchild(
        JSON.parse(localStorage.getItem("filterSubMenuChild_soundfx")) || []
      );
    }
  }, [location.pathname]);

  const handleResultfromMaia = (resultFromAI) => {
    setResultFromMaia(resultFromAI);
  };

  const handleMaiaOnWork = (value) => {
    setMaiaOnWork(value);
  };

  useEffect(() => {
    const X_ACCESS_TOKEN = CookieManager.getCookie("x-access-token");
    const userData = CookieManager.getCookie("user-data");
    if (X_ACCESS_TOKEN && userData !== undefined && userData !== null && userData !== "null") {
      setUserSignedIn(true);
      let details = JSON.parse(userData);
      setUserDetails(details);
    }
  }, []);

  useEffect(() => {
    const userData = CookieManager.getCookie("user-data");
    if (userData !== undefined && userData !== null && userData !== "null") {
      setUserSignedIn(true);
      let details = JSON.parse(userData);
      setUserDetails(details);
         // console.log('User Data :',userDetails)
      //API.updateUserCookie();
    }
    //  else {
    //   Helper.clearStorageAndCookie();
    // }
    },[])

  useEffect(() => {
    let tempDashboardMenu = [...dashboardMenu];
    if (userDetails?.userType === JSON.parse(process.env.REACT_APP_USER_TYPE)?.ADMIN
        || userDetails?.userType === JSON.parse(process.env.REACT_APP_USER_TYPE)?.SUPER_ADMIN
    ) {
      if (!tempDashboardMenu.filter((item) => item.key === "Admin").length) {
        tempDashboardMenu.push({ key: "Admin", value: "/admin" });
      }
    }

    // billing section removed for now,[we can send the invoice from stripe directly to the customer via Email] 
    // TODO : 
    // billing section would only be visible to the Corporate Admin.
    // Admin could control the whole billing thing from this panel and will have invoices insight.
    if ((userDetails?.userType === JSON.parse(process.env.REACT_APP_USER_TYPE)?.ADMIN
        || userDetails?.userType === JSON.parse(process.env.REACT_APP_USER_TYPE)?.SUPER_ADMIN
        || userDetails?.userType === JSON.parse(process.env.REACT_APP_USER_TYPE)?.CORPORATE)
        ){
        tempDashboardMenu = tempDashboardMenu.filter((item) => item.key !== "Subscription");
    }
    setDashboardMenu(tempDashboardMenu);
  }, [userDetails]);

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
    const { pathname } = location;
    setCurrentPathname(pathname);
    const X_ACCESS_TOKEN = CookieManager.getCookie("x-access-token");
    if (X_ACCESS_TOKEN) {
      let unsignedUserRoutes = ["/signin", "/forgot-password"];
      if (
        unsignedUserRoutes.indexOf(pathname) !== -1 ||
        pathname.includes("/reset-password")
      ) {
        window.location = "/";
      }

      if (pathname === "/signup/") {
        window.location.href = `${location.pathname}${location.hash}`;
      }
    }
    if (pathname.indexOf("license") !== -1) {
      setCurrentTrack("");
      setPlayPause(false);
      setCurrentTrackDetail({});
      if (Amplitude.getSongs().length) {
        Amplitude.stop();
        Amplitude.removeSong(0);
      }
    }
    
    const userData = CookieManager.getCookie("user-data");
    if (userData !== undefined && userData !== null && userData !== "null") {
      setUserSignedIn(true);
    }
    // console.log("signed in user : ", userSignedIn)
  }, [location.pathname]);

  useEffect(() => {
    // console.log("signed in user : ", userSignedIn)
  },[userSignedIn])
  const setFetchingTrack = (val) => {
    setLoadingTrack(val);
  };
  const scrollRef = useRef(null);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -150, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 150, behavior: 'smooth' });
    }
  };


  useEffect(() => {
    setShowSubscribePopup(false);
    setShowLogoutPopup(false);
    setSearch(false);
  }, [path, location.pathname]);


  const validateUser = (action) => {
    let profileData = JSON.parse(CookieManager.getCookie("user-data") || "{}");
    let valid = true;
    if (profileData?.email === undefined) {
      valid = false;
    } else {
      let userType = JSON.parse(process.env.REACT_APP_USER_TYPE);
      if(action === Constants.ACTION.SEARCH)
        valid = true;
      else
        switch (profileData.userType) {
          case userType.FREE:
            if (
              action === Constants.ACTION.DOWNLOAD ||
              action === Constants.ACTION.TTS ||
              action === Constants.ACTION.GENERATE_LICENSE
            )
              valid = false;
            break;
          case userType.ADMIN:
            if (
              (profileData.isSuspended ||
                !profileData.subscribed ||
                new Date(profileData.renewalDate).getTime() < new Date().getTime()) &&
              (action === Constants.ACTION.DOWNLOAD ||
                action === Constants.ACTION.TTS ||
                action === Constants.ACTION.GENERATE_LICENSE)
            )
              valid = false;
            break;
          case userType.SOLO:
          case userType.SOLO_PRO:
          case userType.CORPORATE:
            if (
              !profileData.subscribed &&
              (action === Constants.ACTION.DOWNLOAD ||
                action === Constants.ACTION.TTS ||
                action === Constants.ACTION.GENERATE_LICENSE)
            )
              valid = false;
            break;
          default:
            break;
        }
    }
    return valid;
  };

  const showFooter = () => {
    if(isAdminOrSuperAdmin){
      return false;
    }else{
      if(path?.includes("/home") || path?.includes("/about") || path?.includes("/register"))
        return false;
      return true;
    }
  }
  return (
    <ThemeProvider >
      <TrackContext.Provider
        value={{
          setCurrentTrack,
          setCurrentTrackDetail,
          setCurrentTrackImage,
          currentTrack,
          currentTrackDetail,
          currentTrackImage,
          playPause,
          setPlayPause,
          setLoadingTrack,
          totaltracks,
          setTotaltracks,
          previousTrack,
          setpreviousTrack,
          trackData,
          setTrackData,
          trackFilter,
          setTrackFilter,
          filterMenu,
          setFilterMenu,
          userDetails,
          setShowSubscribePopup,
          setCurrPage,
          currPage,
          setUserAction,
          setUserDetails,
          loading,
          setIsLoading,
          showProjectModal,
          setShowProjectModal,
          setCurrentPathname,
          path,
          setFetchingTrack,
          setShowAlertPopups,
          error,
          setError,
          clearData,
          setClearData,
          showMayaLoader,
          setShowMayaLoader,
          allTracksLoaded,
          setAllTracksLoaded,
          resultFromMawoSearch,
          setResultFromMawoSearch,
          filterSubMenu,
          setFilterSubMenu,
          filterSubMenuChild,
          setFilterSubMenuchild,
          stopSearch,
          setStopSearch,
          intervalID,
          setIntervalId,
          searchTime,
          setSearchTime,
          setDefaultImage,
          showProgress,
          setShowProgress,
          progress,
          setProgressValue,
          maiaOnWork,
          handleMaiaOnWork,
          fileName,
          setAudioFileName,
          validateUser,
          isFileUpload,
          setFileUpload,
          cancelToken,
          setCancelToken,
          searchkey,
          setSearchkey,
          searchResultView,
          setSearchResultView,
          searchAlbums,
          setSearchAlbums,
          AISearch,
          setSearch,
          showLoaderMagic,
          setShowLoaderMagic,
          songData,
          setSongData,
          alltrackData,
          setalltrackData,
          setPlayingFrom,
          playingFrom,
          searchDescription,
          setSearchDescription,
          showLogoutPopup,
          setShowLogoutPopup,
          userSignedIn,
          trackToBeAddedToProject,
          setTrackToBeAddedToProject
        }}
      >
        <ErrorBoundary>
          <RouteChangeTracker />
          <div className="">
            <>
              {/* Conditionally render Navbar for non-admin users */}
              {path !== "/home/country-not-available" && (
                <Navbar
                  match={match}
                  location={location}
                  handleMaiaOnWork={handleMaiaOnWork}
                  showProgress={showProgress}
                  handleResultfromMaia={handleResultfromMaia}
                  name={
                    userDetails?.first_name
                      ? `${userDetails?.first_name} ${userDetails?.last_name}`
                      : ""
                  }
                />
              )}

              {AISearch && (
                <AiSearch

                  closeProjectModal={() => {setSearch(false)}}
                  checked={searchDescription}
                />
              )}
              {/* Common Routes */}
              {(!Helper.getGlobalRoutes()?.includes(path) && !path?.includes("/admin")) && !location.pathname?.includes("/blog/") && 
              <div className={userSignedIn ? "w-full flex relative" : "w-full relative"}>
                {userSignedIn && 
                <div className="w-1.5/12 lg:mx-2 my-2 shadow-box rounded-2xl p-2 px-4 hidden lg:block" style={{position : "relative"}}>
                  <SideMenu />
                </div>}
                {userSignedIn && 
                <div className="lg:hidden" style={{position : "relative"}}>
                  <MobileTopNav />
                </div>}
                <div className={!userSignedIn ? "w-full mt-14 p-4" : "w-full rounded-2xl shadow-box m-1 mt-20 lg:mt-2 lg:px-4"}>
                  <Route path="/new-inspiration" component={NewInspiration} />
                  <Route path="/playlists/:playlistId" component={PlaylistDetails} />
                  <Route path="/album/:albumId" component={AlbumDetails} />
                  <Route path="/artist/:artistId" component={ArtistTrackView} />
                  <Route path="/catalogs" component={Catalog} />
                  <Route path="/sfx" component={SFX} />
                  <Route path="/catalog/albums/:catalogId" component={Catalog} />
                  <Route path="/music/tracks/:searchText" component={HarmixLibrary} />
                  <Route path="/music/albums/:searchText" component={HarmixLibrary} />
                  <Route exact path='/' component={HarmixLibrary} />
                  <Route path="/library/:assetId?" component={HarmixLibrary} />
                
                  {userSignedIn && <>
                    <Route path="/projects" component={Projects} />
                    <Route path="/favourites" component={ActionRecords} />
                    <Route path="/history" component={ActionRecords} />
                    <Route path="/downloads" component={Downloads} />
                    <Route path="/profile" component={Account} />
                    <Route path="/billing" component={Billing} />
                    <Route path="/support" component={ContactUs} />
                    <Route path="/licenses" component={AllLicenses} />
                    <Route path="/subscription" component={SubscriptionInfo} />
                    <Route path="/license/:projectId" component={SingleLicense} />
                    <Route path="/harmix/admin" component={HarmixAdmin} />
                  </>}
                </div>
              </div>}
              {/* <Route path="/new-inspiration" component={NewInspiration} /> */}
              {/* <Route path="/playlists/:playlistId" component={PlaylistDetails} /> */}
              <Route path="/signup/" component={Register} />
              <Route path="/register/:planType" component={Enrol} />
              <Route path="/login" component={Login} />
              <Route path="/choose-plan" component={ChoosePlan} />
              {/* <Route path="/album/:albumId" component={AlbumDetails} /> */}
              {/* <Route path="/artist/:artistId" component={ArtistTrackView} /> */}
              <Route path="/sound-fx" component={SoundFx} />
              {/* <Route path="/catalogs" component={Catalog} /> */}
              {/* <Route path="/catalog/albums/:catalogId" component={Catalog} /> */}
              {/* <Route exact path="/home" component={HomePage} /> */}
              {/* <Route exact path="/home">
                <Redirect push reloadDocument to={"/home.html"} />
              </Route>  */}
              {/* <Route path="/home" component={StaticHtmlLoader} /> */}
              <Route exact path="/home" component={HomePage} />
              
              {/* <Route path="/library/:assetId?" component={HarmixLibrary} /> */}
              <Route path="/about" component={AboutPage} />
              <Route path="/terms" component={ServiceTerms} />
              <Route path="/privacy" component={PrivacyPolicy} />
              <Route path="/cookies" component={CookiesPolicy} />
              <Route path="/contact" component={ContactUs} />
              <Route path="/faqs" component={Faqs} />

              <Route exact path="/blogs" component={BlogListing} />
              <Route path="/blog/:slug" component={BlogDetail} />

              <Route path='/home/country-not-available' component={CountryNotAvailable} />
              <Route path="/harmix/admin" component={HarmixAdmin} />
              {/* <Route path="/music/tracks/:searchText" component={HarmixLibrary} /> */}
              {/* <Route path="/music/albums/:searchText" component={HarmixLibrary} /> */}
              {/* <Route exact path='/' component={HarmixLibrary} /> */}
              {/* {(path === "/") && <HarmixLibrary />} */}

              {/* Admin Routes */}
              <Route path="/admin" component={Admin} />
              <Route path="/insights" component={LicenseInsight} />

              {userSignedIn ? (
                <></>
              ) : (
                <>
                  <Switch>
                    {/* <Route path="/new-inspiration" component={NewInspiration} />
                    <Route path="/playlists/:playlistId" component={PlaylistDetails} />
                    <Route path="/album/:albumId" component={AlbumDetails} />
                    <Route path="/catalogs" component={Catalog} />
                    <Route path="/catalog/albums/:catalogId" component={Catalog} />
                    <Route path="/music/tracks/:searchText" component={HarmixLibrary} />
                    <Route path="/music/albums/:searchText" component={HarmixLibrary} />
                    <Route exact path='/' component={HarmixLibrary} />
                    <Route path="/library/:assetId?" component={HarmixLibrary} /> */}

                    <Route
                      path="/email-verification/:token"
                      component={EmailVerification}
                    />
                    <Route path="/signin" component={Login} />
                    <Route path="/confirmation" component={SignupConfirm} />
                    <Route path="/verification" component={SignupVerify} />
                    <Route path="/playlists/:playlistId" component={PlaylistDetails} />
                    <Route path="/404page" component={NotFoundPage} />
                    <Route path="/forgot-password" component={ForgotPassword} />
                    <Route
                      path="/reset-password/:token/:resetCode"
                      component={SetNewPassword}
                    />
                    {[
                      "/projects",
                      "/admin",
                      "/favourites",
                      "/history",
                      "/profile",
                      "/billing",
                      "/support",
                      "/licenses",
                    ].includes(path) ||
                    path.includes("/license/") ? (
                      <Redirect to="/login" />
                    ) : (
                      path !== "/" &&
                      path === `/search/track/${searchkey}` &&
                      path === `/search/albums/${searchkey}` &&
                      path !== "/signin" &&
                      path !== "/signup" &&
                      path !== "/sound-fx" &&
                      path !== "/inspiration" &&
                      path !== "/new-inspiration" &&
                      path !== "/signup/" &&
                      path !== "/confirmation" &&
                      !path.includes("/404page/") &&
                      !path.includes("/playlists/") &&
                      !path.includes("reset-password") &&
                      !path.includes("/catalogs") && (
                        <Route
                          component={() => {
                            window.location.href = process.env.REACT_APP_MKT_SITE_404;
                            return null;
                          }}
                        />
                      )
                    )
                    // <Redirect to='https://www.syncmama.com/404page' /> 
                    }
                  </Switch>
                </>
              )}

              <div id="sync-media-player" className="fixed bottom-0 w-full h-1 z-10" style={{zIndex : "99"}}>
                {loadingTrack && <LinearProgress className="z-20" />}
                {currentTrack !== "" && (
                  <div className="flex justify-center">
                    <MediaPlay
                      currentTrackDetail={currentTrackDetail}
                      currentTrackImage={currentTrackImage}
                      currentTrack={currentTrack}
                    />
                  </div>
                )}
              </div>
              <ToastContainer
                position="bottom-right"
                theme="colored"
                toastClassName="bg-transparent shadow-none p-0"
                toastStyle={{ background: 'transparent', boxShadow: 'none', padding: 0 }}
                bodyClassName="p-0"
                autoClose={5000}
                hideProgressBar={true}
                newestOnTop={false}
                closeButton={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
              {showSubscribePopup ? <SubscribePopup action={userAction} /> : null}
              {showLogoutPopup ? <LogoutPopup /> : null}
              {showAlertPopups ? <AlertSubscribePopup error={error} /> : null}
              {showProjectModal ? (
                    <AddTrackToProjectPopup
                      trackToBeAddedToProject={trackToBeAddedToProject}
                      closeProjectModal={() => {setShowProjectModal(false); setTrackToBeAddedToProject("");}}
                    />
                  ) : null}
              {/* Conditionally render Footer for non-admin users */}
              {showFooter() && <Footer />}
            </>
          </div>
        </ErrorBoundary>
      </TrackContext.Provider>
    </ThemeProvider>
  );
});